import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { ILabTest, LabTest } from '../LabTest.ts';
import { LabTestApi } from '../../../apis/LabTestApi/LabTestApi.ts';

export function useGetLabTests(patientId?: string) {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.labTests, patientId],
        queryFn: async () => {
            const result: ILabTest[] = await LabTestApi.getLabTests(patientId!);
            return result.map((el) => new LabTest(el));
        },
        enabled: !!patientId,
    });
}
